import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import { DocumentRequest } from './types'
import api from '../../../constant/END_POINT'

const postCreateRequestDocument = async (
  claimFormId: string,
  phoneNumber: string,
  documentRequests: DocumentRequest[],
) => {
  const response = await httpClientPrivate.post(api.backoffice.requestDocument, {
    claimFormId,
    phoneNumber,
    documentRequests,
  })

  return response.data
}

const useCreateRequestDocument = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateRequestDocument'],
    mutationFn: async ({
      claimFormId,
      phoneNumber,
      documentRequests,
    }: {
      claimFormId: string
      phoneNumber: string
      documentRequests: Array<DocumentRequest>
    }) => postCreateRequestDocument(claimFormId, phoneNumber, documentRequests),
  })

  return mutation
}
export { useCreateRequestDocument }
